import Vue from 'vue'
import dialogUpdateResult from './src/dialog-update-result.vue'

const DialogUpdateResultConstructor = Vue.extend(dialogUpdateResult)

let instance
const instances = []
let seed = 1

export function PgDialogUpdateResult(options) {
  instance = new DialogUpdateResultConstructor()
  instance.id = `dialog_update_result_${seed++}`

  options.close = function () {
    PgDialogUpdateResult.close(instance.id)
  }

  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.show(options)
  instances.push(instance)
  return instance
}

PgDialogUpdateResult.close = function (id) {
  const index = instances.findIndex((ins) => ins.id === id)
  if (index > -1) {
    instances.splice(index, 1)
  }
}

export function PgDialogUpdateResultUpdate(callback) {
  return new Promise(async (resolve) => {
    let res = []
    let dialogInstance = null
    const closed = () => {
      dialogInstance = null
      resolve(res)
    }
    const update = (options) => {
      options.closed = closed
      if (!dialogInstance) {
        dialogInstance = PgDialogUpdateResult(options)
      } else {
        dialogInstance.updateProps(options)
      }
    }
    res = await callback(update)
    if (res?.[0]?.faild > 0 || (res?.[0]?.success !== true && res?.[0]?.success > 0)) {
      update({
        resultData: res[0],
        downLoadFailUrl: res[0].data,
      })
    } else {
      resolve(res)
    }
  })
}
